import { ExtensionBoilerplate } from '@adornis/buildify/client/extensions/ContentExtensionBoilerplate.js';
import { Size } from '@adornis/buildify/client/globals/enums.js';
import type { BuildifyExtension } from '@adornis/buildify/client/globals/types.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex';
import { consentCookieValueSubject } from '@adornis/digitale-helden-shared/tracking/client/consent-tool.js';
import { CookieFactory } from '@adornis/digitale-helden-shared/tracking/client/types/CookieFactory.js';
import '@adornis/file-utils/client/x-image';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../../client/theme/d-text.js';
import { BaseBetterPlace } from '../db/BaseBetterPlace';

export const MarketingBetterPlace: BuildifyExtension<BaseBetterPlace> = {
  class: BaseBetterPlace,
  toolbar: {
    icon: 'hand-holding-dollar',
    text: {
      default: 'SpendBetterPlace',
    },
  },
  group: 'Marketing',
  render(instance, { isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <marketing-better-place
        .content=${instance}
        .defaultValues=${this.defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></marketing-better-place>
    `;
  },
  editor: () => html` <d-text> Hier kann nichts zusätzlich verändert werden. </d-text> `,
};

@customElement('marketing-better-place')
export class MBetterPlace extends ExtensionBoilerplate<BaseBetterPlace> {
  override connectedCallback(): void {
    super.connectedCallback();

    consentCookieValueSubject.subscribe(value => {
      this.requestUpdate();
    });
  }

  override _content(content: BaseBetterPlace) {
    if (!CookieFactory.consentCookie.getValue('allowBetterPlace', 'boolean'))
      return html`
        <d-flex
          ${css({ width: '100%', aspectRatio: '16 / 4', color: '#fff', background: '#333', padding: '48px 32px' })}
          center
          crossaxis-center
          space="lg"
        >
          <d-text ${css({ textAlign: 'center' })}>
            Bitte aktiviere BetterPlace-Cookies, um die Spende durchzuführen 💚🌍
          </d-text>
          <d-button
            @click=${() => {
              CookieFactory.consentCookie.setValue('allowBetterPlace', 'true');
              this.requestUpdate();
            }}
          >
            Cookies erlauben
          </d-button>
        </d-flex>
      `;

    const size = this._consumedSize.value;
    const heightForIFrame = size === Size.MOBILE ? 1365 : 1400;

    return html`
      <x-flex w100 crossaxis-center>
        <iframe
          height=${heightForIFrame}
          width="100%"
          frameborder="0"
          style="max-width: 1200px; max-height: none; width: 100%; background-color: transparent;"
          src="https://www.betterplace.org/de/projects/36063/iframe_donations/new?background_color=ffffff&amp;color=afcb07&amp;donation_amount=50&amp;bottom_logo=true&amp;recurring_interval=single&amp;utm_campaign=external_donation_forms&amp;utm_source=domain: lasdigitale-helden-michi-marketing-runtime.nexus.adornis.de&amp;utm_medium=project_36063&amp;utm_content=lasdigitale-helden-stieber-marketing-runtime.nexus.adornis.de&amp;"
        >
        </iframe>
      </x-flex>
    `;
  }
}
